import React, { useEffect } from "react";
import { FH } from "../../routes/main-styles";

function VideoMinuatureView({ videoUrl }) {
  const [videoName, setVideoName] = React.useState("");

  useEffect(() => {
    if (videoUrl) {
      fetchVideoName();
    }
  }, [videoUrl]);
function decodeHtmlEntities(text) {
  const parser = new DOMParser();
  const dom = parser.parseFromString(text, "text/html");
  return dom.body.textContent || "";
}
  async function fetchVideoName() {
    try {
      const res = await fetch(
        `https://corsproxy.io/?${encodeURIComponent(videoUrl)}`
      );
      const html = await res.text();

      const match = html.match(/<title>(.*?)<\/title>/i);
      if (match) {
        // O título vem com " - YouTube" no final, normalmente
        let videoName = match[1];
        // Decodifica o título e remove " - YouTube" se existir
        videoName = decodeHtmlEntities(videoName)
          .replace(/ - YouTube$/, "")
          .trim();
        setVideoName(videoName);
      } else {
        throw new Error("Título não encontrado");
      }
    } catch (err) {
      throw new Error("Erro ao buscar título");
    }
  }
  return (
    <FH>
      <img
        src={
          videoUrl.includes("youtube")
            ? "https://img.youtube.com/vi/" +
              videoUrl.split("v=")[1] +
              "/maxresdefault.jpg"
            : "https://via.placeholder.com/150"
        }
        alt="video thumbnail"
        style={{ width: 'auto', height: 60, marginRight: 10, borderRadius: 5, objectFit: 'cover' }}
      />
      <div>

      <div style={{ flex: 1, fontSize: 12, color: "#333", fontWeight: 500 }}>
        {videoName || "Não foi possível obter o título do vídeo"}
      </div>
      <div style={{fontSize: 10, color: "#656565"}}>{videoUrl}</div>
      </div>
    </FH>
  );
}

export default VideoMinuatureView;
